import {
  PUBLIC_GET_ALL_SUBSCRIPTION_SUCCESS,
  PUBLIC_GET_ALL_SUBSCRIPTION_REQUEST,
  PUBLIC_GET_ALL_SUBSCRIPTION_FAIL,
} from "../../types/super-admin/subscriptinTypes";

export const getPublicSubscriptionReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case PUBLIC_GET_ALL_SUBSCRIPTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case PUBLIC_GET_ALL_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        publicSubcription: payload,
        error: "",
      };
    case PUBLIC_GET_ALL_SUBSCRIPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
        publicSubcription: [],
      };

    default:
      return state;
  }
};
